import { Connector } from "../../../config/types";
import NextStepButton from "../../shared/NextStepButton";
import { AlertTriangle } from "lucide-react";
import SuccessScreen from "../../interstitials/SuccessScreen";
import InterstitialScreen from "../../interstitials/InterstitialScreen";

type Props = {
  connector?: Connector;
  isPermissionsError?: boolean;
  onExit: () => void;
  onBack: () => void;
  onNext: () => void;
  translate: (keyString: string, fallbackString: string) => string;
  subtext?: string;
  isBlockingValidationError?: boolean;
};

const ErrorRemediationInitialInterstitial = ({
  connector,
  isPermissionsError,
  onNext,
  translate,
  subtext,
  isBlockingValidationError,
}: Props) => {
  return (
    <>
      {isPermissionsError ? (
        <SuccessScreen
          connector={connector}
          onClickBottomAction={onNext}
          customButtonText={translate("next-button", "Next")}
        />
      ) : (
        <InterstitialScreen
          connector={connector}
          centralIcon={<AlertTriangle className="text-red-50" size={60} strokeWidth={1.5} />}
          text={translate("failed-text", "Failed to connect")}
          bottomAction={
            <NextStepButton onClick={onNext}>
              {!isBlockingValidationError
                ? translate("see-issues-button", "See issues")
                : translate("relink-button", "Relink")}
            </NextStepButton>
          }
          subText={subtext}
          isBlockingValidationError={isBlockingValidationError}
        />
      )}
    </>
  );
};

export default ErrorRemediationInitialInterstitial;
